/**
 * Created with IntelliJ IDEA.
 * User: itaik
 * Date: 2/20/13
 * Time: 10:03 AM
 * To change this template use File | Settings | File Templates.
 *
 *
 * This is used for registering new modules in the framework as long as the
 * registered modules use the framework modules structure conventions - as follows:
 * inside "src/modules" dir:
 *  + module-name
 *      + assets
 *          + css
 *          + img
 *          + js
 *              + lib
 *          + templates
 *      + src
 *          + collections
 *          + controllers
 *          + layouts
 *          + models
 *          + views
 *          moduleName.js
 *          config.js
 *      + test
 *          + unit-tests
 *              + collections
 *              + models
 *              + views
 *              init.js
 *
 */


// todo - rename this module to modules.json


define({
    modules : [
        {    //THE DATA MODULE MUST BE FIRST
            // A change in the "id" property will require a code change
            "id" : "dataModule",
            "moduleName" : "LEDataModule",
            "folderName" : "data-module",
            "regionId" :  "LEDataModuleNA",
            "container" : "LEDataModuleNA",
            //"template":   "LEDataModuleNA",
            "routePrefix" : "LEDataModuleNA",
            "personas" : ["agent", "marketer", "admin"],
            "lazy" : false,
            "autostart" : true,
            "coreComponentsSupportLevel" : 1
        },
        {
            // A change in the "id" property will require a code change
            "id" : "registration",
            "moduleName" : "LERegistration",
            "folderName" : "registration",
            "regionId" : "registration",
            "container" : "work-area-wrapper",
            "template": "workAreaItem",
            "routePrefix" : "registration",
            "xpersonaMapping" : "guest",
            "personas" : ["marketer","guest","admin"],
            "lazy" : true,
            "autostart" : true,
            "transition": true
        },
        {
            // A change in the "id" property will require a code change
            "id":"manager",
            "moduleName":"LEManager",
            "folderName":"manager",
            "regionId":"manager",
            "container" : "work-area-wrapper",
            "template": "workAreaItem",
            "routePrefix":"mng",
            "personas":["agent", "marketer","admin"],
            "lazy":true,
            "autostart" : true,
            "coreComponentsSupportLevel" : 2
        },
        //        {
        //            // A change in the "id" property will require a code change
        //            "id":"example",
        //            "moduleName":"LEExample",
        //            "folderName":"example",
        //            "regionId":"example",
        //            "routePrefix":"exam",
        ////            "personaMapping":"agent",
        //            "personas":["*"],
        //            "lazy":false,
        //            "autostart":true,
        //            "coreComponnentsSupport": "Level1"
        //        },
        {
            // A change in the "id" property will require a code change
            "id" : "webagent",
            "moduleName" : "LEWebAgent",
            "folderName" : "web-agent",
            "regionId" : "web-agent",
            "container" : "work-area-wrapper",
            "template": "workAreaItemNoLEClass",
            "routePrefix" : "wa",
            "personaMapping" : "agent",
            "personas" : ["agent"],
            "lazy" : true,
            "autostart" : true,
            "transition": true,
            "switcher": {
                "control": "switcher-item-agent",
                "index": 1
            }
        },
        {
            // A change in the "id" property will require a code change
            "id" : "campaigns",
            "moduleName" : "LECampaigns",
            "folderName" : "campaigns",
            "regionId" : "campaigns",
            "container" : "work-area-wrapper",
            "template": "workAreaItem",
            "routePrefix" : "camp",
            "personaMapping" : "marketer",
            "personas" : ["marketer"],
            "lazy" : true,
            "autostart" : true,
            "transition": true,
            "coreComponentsSupportLevel" : 2,
            "switcher": {
                "control": "switcher-item-marketer",
                "index": 2
            }
        },
        {
            // A change in the "id" property will require a code change
            "id" : "reporting",
            "moduleName" : "LEReporting",
            "folderName" : "reporting",
            "regionId" : "reporting",
            "container" : "reporting-wrapper",
            "template": "reportingItem",
            "routePrefix" : "data",
            "personas" : ["agent", "marketer", "admin"],
            "lazy" : true,
            "autostart" : true,
            "coreComponentsSupportLevel" : 1
        },
        {
            // A change in the "id" property will require a code change
            "id" : "userManagement",
            "moduleName" : "LEUserManagement",
            "folderName" : "user-management",
            "regionId" : "user-management",
            "container" : "work-area-wrapper",
            "template": "workAreaItem",
            "routePrefix" : "um",
            "personaMapping" : "admin",
            "personas" : ["admin"],
            "lazy" : true,
            "autostart" : true,
            "transition": true,
            "coreComponentsSupportLevel" : 2,
            "switcher": {
                "control": "switcher-item-agent-mngt",
                "index": 3
            }
        },
        {
            // A change in the "id" property will require a code change
            "id" : "content",
            "moduleName" : "LEContent",
            "folderName" : "content",
            "regionId" : "content-management",
            "container" : "work-area-wrapper",
            "template": "workAreaItem",
            "routePrefix" : "cont",
            "personas" : ["marketer", "admin"],
            "lazy" : true,
            "autostart" : true,
            "coreComponentsSupportLevel" : 2
        },
        {
            // A change in the "id" property will require a code change
            "id" : "connection",
            "moduleName" : "LEConnection",
            "folderName" : "connection",
            "regionId" : "connection-bar",
            "container" : "connection-bar-wrapper",
            "template": "connectionItem",
            "routePrefix" : "con",
            "transition":false,
            "personas" : ["agent","marketer","guest","admin"],
            "lazy" : true,
            "autostart" : true,
            "coreComponentsSupportLevel" : 1
        },
        {
            // A change in the "id" property will require a code change
            "id" : "personalization",
            "moduleName" : "LEPersonalization",
            "folderName" : "personalization",
            "regionId" : "personalization",
            "container" : "personalization-bar-wrapper",
            "template": "personalizationItem",
            "routePrefix" : "pers",
            "personas" : ["customizer"],
            "lazy" : true,
            "autostart" : true,
            "coreComponentsSupportLevel" : 2
        },
        {
            // A change in the "id" property will require a code change
            "id" : "automation",
            "moduleName" : "LEAutomation",
            "folderName" : "automation",
            "regionId" : "automation",
            "container" : "work-area-wrapper",
            "template": "workAreaItem",
            "routePrefix" : "automation",
            "personas" : ["automation"],
            "lazy" : true,
            "autostart" : true,
            "coreComponentsSupportLevel" : 2,
            "switcher": {
                "control": "switcher-item-automation-platform",
                "index": 4
            }
        }
        //        {
        //            "id": "utils",
        //            "moduleName": "LEUtils",
        //            "folderName": "utils",
        //            "regionId": "webAgent",
        //            "routePrefix": "utils",
        //            "personas": ["*"],
        //            "lazy": false,
        //            "autostart":true
        //        }
    ]
});
